import { makeStyles, shorthands } from "@fluentui/react-components";

export const useQuickViewStyles = makeStyles({
    root: {
        display: 'flex',
        // width: "100%",
        flexDirection: 'column',
        ...shorthands.overflow("auto"),
    },
    iconmarge: {
        marginLeft: '10px',
        marginRight: '10px',
    },
    titleAndOps: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        ...shorthands.gap("5px"),
    },
    titleAndOpsButtons: {
        display: "flex",
        flexDirection: "row",
        marginLeft: "auto",
        textWrap: "nowrap",
        ...shorthands.gap("5px"),
    },
    InlineRow: {
        display: "flex",
        flexDirection: "row",
        textWrap: "nowrap",
        ...shorthands.gap("10px"),
    },
    Column: {
        display: 'flex',
        flexDirection: 'column',
    },
});

